import { ToastContainer } from 'react-toastify';

const Quarter = () => {
	return (
		<>
			<div className="home">
				<h1 className="text-align--center">QUARTER HERE!</h1>
			</div>
			<ToastContainer />
		</>
	);
};

export default Quarter